export const templateFontList = [
  "Anton",
  "Bebas Neue",
  "Comfortaa",
  "Dancing Script",
  "Graduate",
  "Lobster",
  "Lora",
  "Montserrat",
  "Oswald",
  "Pacifico",
  "Playfair Display",
  "Racing Sans One",
  "Roboto",
  "Sacramento",
  "Tourney",
];
